<div class="backdrop" (click)="onClose()"></div>
<div class="slide-panel my-widgets-slider-panel">
  <div class="slider-header">
    <div class="title-wrapper">
      <div class="title-line">
        <h3 class="slider-title">My Widgets</h3>
        <span class="selected-count-badge">{{ selectedWidgetsCount() }} selected</span>
      </div>
    </div>
    <div class="slider-header-actions">
      <button type="button" class="close-btn" (click)="onClose()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="slider-body">
    @if (loading()) {
      <div class="loading-container">
        <app-spinner [size]="30"></app-spinner>
      </div>
    } @else if (widgets().length === 0) {
      <div class="no-widgets-container">
        <i class="fas fa-th-large no-widgets-icon"></i>
        <h4 class="no-widgets-title">No Widgets Available</h4>
        <p class="no-widgets-message">There are no widgets assigned to your account. Please contact your administrator to get widgets added to your dashboard.</p>
      </div>
    } @else {
      <div class="widgets-toolbar">
        <p class="widgets-help">Pick the cards to show on your homepage</p>
        <button type="button" class="btn-reset" (click)="onReset()" [disabled]="applying() || loading()" aria-label="Reset widgets">
          <mat-icon>replay</mat-icon>
          Reset
        </button>
      </div>
      <div class="widgets-grid">
        @for (item of widgets(); track item.id) {
          <button
            type="button"
            class="widget-card"
            [class.selected]="item.checked"
            [attr.aria-pressed]="item.checked"
            (click)="onToggleWidget(item)"
          >
            <span
              class="card-label"
              [matTooltip]="item.label ?? item.name"
              matTooltipPosition="above"
            >
              {{ item.label ?? item.name }}
            </span>
            <span class="card-check" [attr.aria-hidden]="true">
              @if (item.checked) {
                <mat-icon>check</mat-icon>
              }
            </span>
          </button>
        }
      </div>
    }
  </div>

  <div class="slider-footer">
    <div class="footer-right">
      <button type="button" class="btn btn-save" (click)="onApply()" [disabled]="applying()">
        @if (applying()) {
          <app-spinner [size]="18"></app-spinner>
        } @else {
          Save
        }
      </button>
      <button type="button" class="btn btn-cancel" (click)="onCancel()" [disabled]="applying()">
        Cancel
      </button>
     
    </div>
  </div>
</div>
